import React, { useState, useEffect } from "react";
import Spinner from "../../../components/helpers/Spinner";
import { fetchAxiosNoToken } from "../../../helpers/fetchAxiosNoToken";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../../hooks/hooks";
import iconoBluecorner from "../../../img/bluecornericono.png";
import iconoAirbnb from "../../../img/airbnb-logo.png";
import iconoBooking from "../../../img/booking-logo.png";
import iconoTripadvisor from "../../../img/tripadvisor-logo.png";
import BotonInformacion from "../../../components/helpers/BotonInformacion";
import { useNavigate } from "react-router-dom";
import { ButtonRegresar } from "../../../components/ButtonRegresar";
import { ModalEditVariablePrice } from "./ModalEditVariablePrice";
import { Casa } from "./CalendarioHotelHabitacion";

// --- INTERFACES ---
interface Precio {
    precio: string;
    moneda: string;
}

interface VariablePrice {
    id: number;
    id_habitacion: number;
    fecha: string;
    precio: string;
}

interface NoDisponible {
    dia_final: string;
    dia_inicio: string;
    fecha_final: string;
    fecha_inicio: string;
    id: number;
    id_casa: string;
    tipo: string;
}

interface Fechas {
    id?: number;
    fecha: string;
    motivo: string;
}
export interface Selected {
    price: string;
    date: string;
    fechaNoDisponible: Fechas | false;
}

interface Dias {
    id?: number;
    dia: number;
    motivo: string;
    fecha_inicio: string;
    fecha_final: string;
}

export interface Reservas {
    id_pedido: number;
    fecha: string;
}

// --- CONSTANTES GLOBALES ---
const monthTransform = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
];

export const CalendarioListadoHotelHabitacion = (casa: {
    casa: Casa;
    getCasa: () => void;
}) => {
    const navigate = useNavigate();
    const { tipo_moneda } = useAppSelector(
        (state) => state.landing_house.house
    );
    const [date, setDate] = useState(new Date());
    const [modalVisiblePrice, setModalVisiblePrice] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const [precioBase, setPrecioBase] = useState<Precio>({
        precio: casa.casa.precio_base,
        moneda: tipo_moneda,
    });
    const [variablePrice, setVariablePrice] = useState<VariablePrice[]>([]);
    const [arrayDias, setArrayDias] = useState<Dias[]>([]);
    const [arrayFechas, setArrayFechas] = useState<Fechas[]>([]);
    const [arrayDiasBluecorner, setArrayDiasBluecorner] = useState<number[]>(
        []
    );
    const [arrayMesBluecorner, setArrayMesBluecorner] = useState<number[]>([]);
    const [arrayPedidos, setArrayPedidos] = useState<Reservas[]>([]);

    const [arrayFechasBluecorner, setArrayFechasBluecorner] = useState<
        string[]
    >([]);
    const [arrayFechasAirBnb, setArrayFechasAirBnb] = useState<string[]>([]);
    const [arrayFechasBooking, setArrayFechasBooking] = useState<string[]>([]);
    const [arrayFechasTripadvisor, setArrayFechasTripadvisor] = useState<
        string[]
    >([]);
    const [arrayPedidosBluecorner, setArrayPedidosBluecorner] = useState<
        string[]
    >([]);

    const [selected, setSelected] = useState<Selected>({
        date: "",
        price: "",
        fechaNoDisponible: false,
    });
    const [modalDesbloqueo, setModalDesbloqueo] = useState(false);

    function bgColorPorMotivo(motivo: string): string {
        const colores: { [key: string]: string } = {
            Airbnb: "#EC7063",
            Booking: "#5DADE2",
            Alquilado: "#48C9B0",
            "En mantenimiento": "#F4D03F",
            "Evento privado": "#A569BD",
            Otro: "#566573",
        };
        return colores[motivo] || "#000000";
    }

    const handleClick = (direction: "previous" | "next") => {
        const newDate = new Date(date);
        if (direction === "previous") {
            newDate.setMonth(newDate.getMonth() - 1);
        } else {
            newDate.setMonth(newDate.getMonth() + 1);
        }
        setDate(newDate);
    };

    const daysPast = (year: number, month: number, day: number) => {
        const today = new Date();
        const dateToCompare = new Date(year, month - 1, day);
        return dateToCompare.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
    };

    const getAllPreciosVariables = async () => {
        try {
            const data = await fetchAxiosNoToken({
                url: `/precios_variables_habitaciones/getAll/${casa.casa.id}`,
            });
            setVariablePrice(data);
            setLoading(true);
        } catch (error: any) {
            console.log(error.response);
        }
    };

    useEffect(() => {
        if (casa) {
            setLoading(false);
            getAllPreciosVariables();
            setArrayDias(casa.casa.disponibilidades.arrayDias);
            setArrayFechas(casa.casa.disponibilidades.arrayFechas);
        }

        setPrecioBase({
            precio: casa.casa.precio_base,
            moneda: tipo_moneda,
        });
    }, [casa, tipo_moneda]);

    useEffect(() => {
        if (!modalVisiblePrice) {
            setSelected({
                date: "",
                price: "",
                fechaNoDisponible: false,
            });
        }
    }, [modalVisiblePrice]);

    const navegar = (id: number) => {
        window.open(`/dashboard/reservas/${id}`, "_blank");
    };

    // --- FUNCIÓN PARA BORRAR DISPONIBILIDAD ---
    const handleDeleteDisponibilidad = async (id: number) => {
        console.log(id);
        try {
            setLoading(true); // Opcional: mostrar loading
            await fetchAxiosToken({
                url: `/disponibilidades_habitaciones_hoteles/delete/${id}`,
                method: "delete",
            });

            // Recargar datos para que se actualice el calendario
            if (casa.getCasa) {
                casa.getCasa();
            }
        } catch (error: any) {
            console.log("Error al eliminar:", error);
            alert("Hubo un error al eliminar la disponibilidad.");
        } finally {
            // setLoading(false); // Si usas loading global, esto se maneja en el useEffect al recibir data nueva
        }
    };

    const renderCalendar = () => {
        const currentMonth = date.getMonth();
        const currentYear = date.getFullYear();
        const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
        const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0);
        const monthDays = lastDayOfMonth.getDate();
        const monthName = new Intl.DateTimeFormat("es-ES", {
            month: "long",
        }).format(date);
        const days = [
            "Lunes",
            "Martes",
            "Miercoles",
            "Jueves",
            "Viernes",
            "Sabado",
            "Domingo",
        ];
        const dayOfWeek = firstDayOfMonth.getUTCDay();
        let calendar = [];
        let week = [];

        const dayTransform = [6, 0, 1, 2, 3, 4, 5];

        for (let i = 0; i < dayTransform[dayOfWeek]; i++) {
            week.push(<td key={i + 60} className="border bg-gray-50"></td>);
        }

        for (let i = 1; i <= monthDays; i++) {
            if (week.length === 7) {
                calendar.push(
                    <tr key={i} className="">
                        {week}
                    </tr>
                );
                week = [];
            }

            const fechaString = `${currentYear}-${
                monthTransform[currentMonth]
            }-${i > 9 ? i : "0" + i}`;
            const fechaDate = new Date(fechaString);

            // --- BÚSQUEDAS ---
            let price = variablePrice.find((x) => x.fecha === fechaString);
            let reservation = arrayPedidos.find((x) => x.fecha === fechaString);
            let reservationBC = arrayPedidosBluecorner.find(
                (x) => x === fechaString
            );
            let weekday = fechaDate.getUTCDay();

            // Buscar bloqueo por fecha específica
            let fechaNoDisponible = arrayFechas.find(
                (x) => x.fecha === fechaString
            );

            // Buscar bloqueo por rango/día recurrente
            let diaNoDisponible = arrayDias.find(
                (dia) =>
                    (dia.dia ? dia.dia === weekday : true) &&
                    fechaDate <= new Date(dia.fecha_final) &&
                    fechaDate >= new Date(dia.fecha_inicio)
            );

            // --- ID PARA BORRAR (Nuevo) ---
            const idParaBorrar = diaNoDisponible?.id || fechaNoDisponible?.id;

            // --- LÓGICA DE VISUALIZACIÓN ---
            // 1. ¿Es bloqueo externo?
            const isExternalBlock =
                arrayDiasBluecorner.includes(weekday) ||
                arrayMesBluecorner.includes(currentMonth) ||
                arrayFechasBluecorner.includes(fechaString) ||
                arrayPedidosBluecorner.includes(fechaString) ||
                arrayFechasAirBnb.includes(fechaString) ||
                arrayFechasBooking.includes(fechaString) ||
                arrayFechasTripadvisor.includes(fechaString);

            // 2. ¿Es bloqueo local (manual)?
            const isLocalBlock =
                !isExternalBlock && (diaNoDisponible || fechaNoDisponible);

            // 3. ¿Es fecha pasada?
            const isPast = daysPast(
                currentYear,
                Number(monthTransform[currentMonth]),
                Number(i)
            );

            // Clases CSS
            let tdClasses = "py-2 border md818:p-4 group ";
            if (reservation) {
                tdClasses += "cursor-pointer";
            } else if (isLocalBlock) {
                tdClasses += "cursor-pointer";
            } else if (isExternalBlock) {
                tdClasses += "cursor-not-allowed";
            } else if (isPast) {
                tdClasses += "cursor-pointer bg-[#029BFC] bg-opacity-20";
            } else {
                tdClasses += "cursor-default";
            }

            week.push(
                <td
                    onClick={() => {
                        // Click en la celda general
                        if (reservation) {
                            navegar(reservation.id_pedido);
                        } else if (isLocalBlock) {
                            // Si hacen click en el fondo de la celda bloqueada, podrías abrir modal
                            setModalDesbloqueo(true);
                        } else if (isPast && !isExternalBlock) {
                            setSelected({
                                price: price ? price.precio : precioBase.precio,
                                date: fechaString,
                                fechaNoDisponible: fechaNoDisponible
                                    ? fechaNoDisponible
                                    : false,
                            });
                            setModalVisiblePrice(true);
                        }
                    }}
                    key={i}
                    className={tdClasses}
                >
                    <div className="relative">
                        <div className="flex items-center justify-between ">
                            {/* LOGOS EXTERNOS */}
                            {!reservation && (
                                <div className="flex">
                                    {(arrayDiasBluecorner.includes(weekday) ||
                                        arrayFechasBluecorner.includes(
                                            fechaString
                                        ) ||
                                        arrayMesBluecorner.includes(
                                            currentMonth
                                        ) ||
                                        arrayPedidosBluecorner.includes(
                                            fechaString
                                        )) && (
                                        <img
                                            alt="logo bluecorner"
                                            src={iconoBluecorner}
                                            className="w-2 h-2 xs:w-4 xs:h-4"
                                        />
                                    )}
                                    {arrayFechasAirBnb.includes(
                                        fechaString
                                    ) && (
                                        <img
                                            alt="logo airbnb"
                                            src={iconoAirbnb}
                                            className="w-2 h-2 mr-[3px] xs:w-4 xs:h-4"
                                        />
                                    )}
                                    {arrayFechasBooking.includes(
                                        fechaString
                                    ) && (
                                        <img
                                            alt="logo booking"
                                            src={iconoBooking}
                                            className="w-2 h-2 rounded-full xs:w-4 xs:h-4"
                                        />
                                    )}
                                    {arrayFechasTripadvisor.includes(
                                        fechaString
                                    ) && (
                                        <img
                                            alt="logo tripadvisor"
                                            src={iconoTripadvisor}
                                            className="w-2 h-2 rounded-full xs:w-4 xs:h-4"
                                        />
                                    )}
                                </div>
                            )}

                            {/* TEXTO DE MOTIVOS */}
                            {!reservation &&
                                !reservationBC &&
                                !isExternalBlock && (
                                    <>
                                        {fechaNoDisponible ? (
                                            <div className="flex items-center">
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            bgColorPorMotivo(
                                                                fechaNoDisponible.motivo
                                                            ),
                                                    }}
                                                    className="w-2 h-2 rounded-full"
                                                ></div>
                                                <p className="ml-1 text-xs">
                                                    {fechaNoDisponible.motivo}
                                                </p>
                                            </div>
                                        ) : diaNoDisponible ? (
                                            <div className="flex items-center">
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            bgColorPorMotivo(
                                                                diaNoDisponible.motivo
                                                            ),
                                                    }}
                                                    className="w-2 h-2 rounded-full"
                                                ></div>
                                                <p className="ml-1 text-xs">
                                                    {diaNoDisponible.motivo}
                                                </p>
                                            </div>
                                        ) : null}
                                    </>
                                )}

                            <p className="text-[8px] text-right xs:text-sm lg:text-lg lg1170:text-xl ">
                                {i}
                            </p>
                        </div>

                        {/* PRECIO */}
                        <p className="text-[8px] text-center xs:text-xs md:text-base 2xl:text-x ">
                            {price ? price.precio : precioBase.precio}
                            <span className="ml-1 text-[5px] md:text-base 2xl:text-xl ">
                                {precioBase.moneda}
                            </span>
                        </p>

                        {/* INDICADOR DE RESERVA */}
                        {(reservation || reservationBC) && (
                            <p className="xs:px-2 xs:py-1 text-[8px] md:text-[10px] 2xl:text-xs text-center xs:rounded-md text-[#808080] bg-[#E6E6E6] text-opacity-90 relative top-1 group-hover:text-white">
                                {reservationBC
                                    ? "Reservado"
                                    : `Reservado #${reservation?.id_pedido}`}
                            </p>
                        )}

                        {/* BLOQUEO NO DISPONIBLE */}
                        {(isExternalBlock || isLocalBlock) &&
                            !reservation &&
                            !reservationBC && (
                                <div className="xs:px-2 xs:py-[2px] text-[5px] xs:text-[8px] lg:text-xs text-center xs:rounded-lg bg-white text-gray-400 text-opacity-90 relative top-1 group-hover:text-white">
                                    {isExternalBlock ? (
                                        // CASO 1: EXTERNO (Solo visual)
                                        <div className="flex items-center bg-[#FF6969] text-white justify-center xs:rounded-md cursor-not-allowed">
                                            <span>no disponible</span>
                                        </div>
                                    ) : (
                                        // CASO 2: LOCAL (Click para borrar)
                                        <div
                                            className="cursor-pointer hover:bg-red-700 transition-colors py-[3px] bg-[#FF6969] text-white xs:rounded-md"
                                            onClick={(e) => {
                                                e.stopPropagation(); // Evita conflicto con el click de la celda
                                                if (idParaBorrar) {
                                                    handleDeleteDisponibilidad(
                                                        idParaBorrar
                                                    );
                                                }
                                            }}
                                        >
                                            no disponible (x)
                                        </div>
                                    )}
                                </div>
                            )}

                        {/* ETIQUETA 'DISPONIBLE' */}
                        {!reservation &&
                            isPast &&
                            !isExternalBlock &&
                            !isLocalBlock && (
                                <p className="xs:px-2 xs:py-1 text-[8px] xs:text-xs text-center xs:rounded-md text-[#808080] bg-white text-opacity-90 relative top-1 group-hover:text-white">
                                    Disponible
                                </p>
                            )}
                    </div>
                </td>
            );
        }

        if (week.length) {
            for (let i = week.length; i < 7; i++) {
                week.push(<td key={i + 40} className="border bg-gray-50"></td>);
            }
            calendar.push(<tr key={"key"}>{week}</tr>);
        }

        return (
            <>
                <div className="mt-8 ml-4 ">
                    <ButtonRegresar
                        className="-ml-2"
                        arrowColor="black"
                        textColor="black"
                    />
                </div>
                <div className="flex flex-row justify-between w-full mt-10 mb-4 ">
                    <div className="flex items-center justify-center">
                        <div className="relative flex items-center justify-center 2xl:mr-8 md:mr-6">
                            <p className=" text-base lg:text-2xl 2xl:text-3xl font-bold text-[#029BFC] pl-1 xs:pl-5">
                                {monthName.toLocaleUpperCase()} {currentYear}
                            </p>
                            <BotonInformacion text="Aca puedes colocar tus costos por noches y ver las noches reservadas y no disponibles" />
                        </div>
                        <div
                            onClick={() => handleClick("previous")}
                            className="px-1 py-1 border-2 border-[#029BFC] transition ease-in rounded-lg cursor-pointer hover:scale-105 mr-3 2xl:mr-6"
                        >
                            <svg
                                className="2xl:h-6 2xl:w-6 w-4 h-4 text-[#029BFC]"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" />{" "}
                                <polyline points="15 6 9 12 15 18" />
                            </svg>
                        </div>
                        <div
                            onClick={() => handleClick("next")}
                            className="px-1 py-1 border-2 border-[#029BFC] transition ease-in rounded-lg cursor-pointer hover:scale-105"
                        >
                            <svg
                                className="2xl:h-6 2xl:w-6 w-4 h-4 text-[#029BFC]"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </div>
                    </div>
                    <div className="flex items-center justify-center">
                        <button
                            onClick={() =>
                                navigate(
                                    `/dashboard-hotel/noche-no-disponibles/${casa.casa.id}`
                                )
                            }
                            className="flex justify-end 2xl:p-3 lg:p-2.5 p-2 2xl:m-2 lg:m-1.5 m-1 border-2 border-[#CCCCCC] rounded-md hover:text-white text-[#4D4D4D] hover:bg-[#029BFC] hover:border-[#029BFC] 2xl:text-base text-xs"
                        >
                            Días no disponibles
                        </button>
                    </div>
                </div>

                <table className="w-full px-2 table-auto">
                    <thead>
                        <tr>
                            {days.map((day) => (
                                <th
                                    key={day}
                                    className="text-center lg1170:p-2 text-sm md:text-xl 2xl:text-2xl text-[#029BFC] uppercase"
                                >
                                    {day.slice(0, 3)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="">{calendar}</tbody>
                </table>
            </>
        );
    };

    return (
        <div className="w-full px-2 mx-auto ">
            {selected.price !== "" && (
                <ModalEditVariablePrice
                    idCasa={casa.casa.id || 0}
                    modalVisiblePrice={modalVisiblePrice}
                    setModalVisiblePrice={setModalVisiblePrice}
                    moneda={precioBase.moneda}
                    setVariablePrice={setVariablePrice}
                    selected={selected}
                    getCasa={casa.getCasa}
                />
            )}
            {loading && tipo_moneda ? (
                renderCalendar()
            ) : (
                <div className="flex-col items-center justify-center">
                    <div className="flex items-center justify-center mx-auto w-28 h-28">
                        <Spinner width={28} />
                    </div>
                    <div className="mt-5 text-xl text-center">
                        Por favor, aguarde mientras cargamos los datos.
                    </div>
                </div>
            )}
        </div>
    );
};
